import { Component, Prop } from '@stencil/core';
import { Price } from '../../../types/types';
import { Unsubscribe } from '@stencil/redux';
import { store } from '../../../redux/store';
import { RootState } from '../../../redux/reducers';
import { formatPrice, t } from '../../../redux/utils';

@Component({
  tag: 'rentware-total-vat',
  shadow: false,
})
export class RentwareTotalVat {
  @Prop() price: Price;
  @Prop({ mutable: true }) displayNet: boolean;

  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        displayNet: state.system.pricing.priceDisplay === 'net',
      };
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  get totalVat(): string {
    if (!this.price) {
      return null;
    }

    const price = this.price.vat;
    const transParams = { vat: formatPrice(price) };

    return t(this.displayNet ? 'cart.vatExcluded' : 'cart.vat', transParams);
  }

  render() {
    return this.totalVat;
  }
}
